import React, { useRef, useEffect, useState } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

const CustomQuillEditor = ({ value, onChange, placeholder, className }) => {
  const editorRef = useRef(null);
  const quillRef = useRef(null);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (!isMounted || !editorRef.current) return;

    // Initialize Quill editor
    const quill = new Quill(editorRef.current, {
      theme: 'snow',
      modules: {
        toolbar: [
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          [{ 'font': [] }],
          [{ 'size': ['small', false, 'large', 'huge'] }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ 'color': [] }, { 'background': [] }],
          [{ 'script': 'sub'}, { 'script': 'super' }],
          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          [{ 'indent': '-1'}, { 'indent': '+1' }],
          [{ 'align': [] }],
          ['blockquote', 'code-block'],
          ['link', 'image', 'video'],
          ['clean']
        ],
      },
      formats: [
        'header', 'font', 'size',
        'bold', 'italic', 'underline', 'strike',
        'color', 'background',
        'script',
        'list',  'indent',
        'align',
        'blockquote', 'code-block',
        'link', 'image', 'video'
      ],
      placeholder: placeholder || 'Enter your message here...'
    });

    // Set initial value
    if (value) {
      quill.root.innerHTML = value;
    }

    // Handle text change
    quill.on('text-change', () => {
      const html = quill.root.innerHTML;
      onChange(html);
    });

    quillRef.current = quill;

    return () => {
      if (quillRef.current) {
        quillRef.current = null;
      }
    };
  }, [isMounted, placeholder]);

  useEffect(() => {
    if (quillRef.current && value !== quillRef.current.root.innerHTML) {
      quillRef.current.root.innerHTML = value || '';
    }
  }, [value]);

  if (!isMounted) {
    return (
      <div 
        className={`quill-editor-loading ${className || ''}`}
        style={{ height: '300px', border: '1px solid #ccc' }}
      >
        Loading editor...
      </div>
    );
  }

  return (
    <div 
      ref={editorRef} 
      className={`quill-editor ${className || ''}`}
      style={{ height: '300px', marginBottom: '50px' }}
    />
  );
};

export default CustomQuillEditor;
